import React from 'react';

// A row of underlined tabs (ui-architecture.md "Underlined Tabs"):
// `tabs` is [{ key, label, help }], `help` being an optional element shown
// beside the label (e.g. a FieldHelp "?").
const TABS_ROW_STYLE = { display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap', borderBottom: '1px solid #b3bbc7' };
const TAB_WRAP_STYLE = { display: 'flex', alignItems: 'center', gap: 2, paddingBottom: 10 };

function tabColors(selected) {
  return {
    fontWeight: selected ? 700 : 400,
    color: selected ? '#222' : '#666',
    borderBottom: selected ? '2px solid #000' : '2px solid transparent',
  };
}

export default function UnderlinedTabs({ tabs, value, onChange }) {
  return (
    <div style={TABS_ROW_STYLE}>
      {tabs.map((tab) => {
        const colors = tabColors(tab.key === value);
        return (
          <div key={tab.key} style={{ ...TAB_WRAP_STYLE, borderBottom: colors.borderBottom, marginBottom: -1 }}>
            <button
              type="button"
              onClick={() => onChange(tab.key)}
              style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontSize: 14, fontWeight: colors.fontWeight, color: colors.color }}
            >
              {tab.label}
            </button>
            {tab.help}
          </div>
        );
      })}
    </div>
  );
}
